import axios from "axios";
import {
  GENDER_LIST_REQUEST,
  GENDER_LIST_SUCCESS,
  GENDER_LIST_FAIL,
} from "../constants/genderConstants";
import { api2 } from "../core/api";

export const getGenders = () => async (dispatch) => {
  try {
    dispatch({
      type: GENDER_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.get("/gender", config);

    var dt = data.Result;

    // if (typeof dt === "string") {
    //   dispatch({
    //     type: GENDER_LIST_FAIL,
    //     payload: dt.replace("Error - ", ""),
    //   });
    // } else {
    dispatch({
      type: GENDER_LIST_SUCCESS,
      payload: dt,
    });
    // }
  } catch (error) {
    dispatch({
      type: GENDER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
